import Cookies from 'js-cookie'
import { API } from '../../App';



export const getServiceProvider = async (payload,token) => {
      let result
      try {
            result = await API.post("/service-provider-list", payload, { headers: { authorization: `${token}` } })

      } catch (error) {
            console.log(error)
      }
      return result?.data
}
export const serviceProviderEdit = async (payload,token) => {
      let result
      try {
            result = await API.post("/edit-service-provider", payload, { headers: { authorization: `${token}` } })

      } catch (error) {
            console.log(error)
      }
      return result?.data
}
export const deleteServiceProvider = async (payload,token) => {
      let result
      try {
            result = await API.post("/delete-service-provider", payload, { headers: { authorization: `${token}` } })

      } catch (error) {
            console.log(error)
      }
      return result?.data
}
